import React from 'react';
import { useReveal } from '../lib/useReveal';
import { trackEvent } from '../lib/pixel';
const TIERS = [{
  id: 'base',
  badge: null as string | null,
  title: 'MegaPack Integral',
  tagline: 'Aprendé Biodescodificación',
  price: '$19.990',
  includes: ['6 Tomos Profesionales', '6 Bonos Exclusivos', 'Certificado Digital', 'Acceso Inmediato'],
  value: null as string | null,
  cta: 'SI, QUIERO LA FORMACIÓN',
  href: 'https://biodecodificacion-integral.impultienda.ar/checkout',
  accent: 'gold'
}];
type Tier = (typeof TIERS)[number];
function TierCard({
  tier,
  index
}: {
  tier: Tier;
  index: number;
}) {
  const [ref, vis] = useReveal();
  const isGold = tier.accent === 'gold';
  const isDark = tier.accent === 'dark';
  const cardBg = isGold ? 'bg-[#ffffff]' : isDark ? 'bg-[#2E4F48]' : 'bg-[#ffffff]';
  const cardBorder = isGold ? 'border-2 border-[#C2683D]/80' : isDark ? 'border-2 border-[#1C3B36]' : 'border border-[#2E4F48]/25';
  const shadowClass = isGold ? 'shadow-lg' : isDark ? 'shadow-xl' : 'shadow-md';
  const titleColor = isDark ? 'text-[#ffffff]' : 'text-[#1C3B36]';
  const taglineColor = isDark ? 'text-[#C2683D]' : 'text-[#44574F]';
  const includesLabelColor = isDark ? 'text-[#E8E0D3]/90' : 'text-[#44574F]';
  const itemTextColor = isDark ? 'text-[#ffffff]' : 'text-[#1C3B36]';
  const checkColor = isGold ? 'text-[#C2683D]' : isDark ? 'text-[#C2683D]' : 'text-[#44574F]';
  const priceColor = isDark ? 'text-[#ffffff]' : 'text-[#1C3B36]';
  const arsColor = isDark ? 'text-[#E8E0D3]' : 'text-[#44574F]';
  const dividerColor = isGold ? 'border-[#C2683D]/30' : isDark ? 'border-[#ffffff]/20' : 'border-[#2E4F48]/20';
  const buttonClass = isGold ? 'bg-[#C2683D] hover:bg-[#A8542F] text-[#ffffff] shadow-[0_8px_20px_rgba(194,104,61,0.3)] hover:shadow-[0_12px_25px_rgba(194,104,61,0.4)]' : isDark ? 'bg-[#C2683D] hover:bg-[#A8542F] text-[#ffffff] shadow-[0_8px_20px_rgba(194,104,61,0.3)]' : 'bg-[#1C3B36] hover:bg-[#2E4F48] text-white shadow-md hover:shadow-lg';
  const badgeBg = isGold ? 'bg-[#C2683D]' : isDark ? 'bg-[#C2683D] text-[#ffffff]' : '';
  const emphasis = isGold ? 'ring-2 ring-[#C2683D]/40 sm:scale-[1.04] z-10' : '';
  return <div ref={ref} id={tier.id} className={`reveal relative ${cardBg} ${cardBorder} ${shadowClass} ${emphasis} rounded-2xl p-4 md:p-6 flex flex-col scroll-mt-[180px] md:scroll-mt-8 ${vis ? 'is-visible' : ''}`} style={{
    transitionDelay: `${index * 80}ms`
  }} data-id="element-143">
      {tier.badge && <div className={`absolute -top-3 left-1/2 -translate-x-1/2 ${badgeBg} ${isDark ? '' : 'text-white'} text-[10px] font-bold tracking-[0.2em] px-4 py-1.5 rounded-full whitespace-nowrap shadow-sm`} data-id="element-144">
          {tier.badge}
        </div>}

      <h3 className={`text-base md:text-xl font-serif font-bold ${titleColor} mb-0.5 leading-tight mt-1`} data-id="element-145">
        {tier.title}
      </h3>
      <p className={`${taglineColor} text-[11px] sm:text-sm font-semibold mb-2.5 md:mb-4`} data-id="element-146">
        {tier.tagline}
      </p>

      <p className={`${includesLabelColor} text-[9px] md:text-[10px] font-bold uppercase tracking-[0.2em] mb-2`} data-id="element-147">
        Incluye:
      </p>

      <ul className="space-y-1 md:space-y-1.5 mb-3 md:mb-4 flex-grow" data-id="element-148">
        {tier.includes.map((item, i) => <li key={i} className="flex items-start gap-1.5 md:gap-2" data-id="element-149">
            <span className={`${checkColor} flex-shrink-0 mt-0.5 font-bold text-[11px] md:text-xs`} data-id="element-150">
              ✓
            </span>
            <span className={`${itemTextColor} text-[12px] md:text-[13px] leading-snug font-medium`} data-id="element-151">
              {item}
            </span>
          </li>)}
      </ul>

      <div className={`text-center mb-3 md:mb-4 pt-2.5 md:pt-3 border-t ${dividerColor}`} data-id="element-152">
        <div className="flex items-baseline gap-1.5 justify-center" data-id="element-153">
          <span className={`text-xl md:text-3xl font-extrabold ${priceColor} leading-none`} data-id="element-154">
            {tier.price}
          </span>
          <span className={`${arsColor} text-xs md:text-sm font-semibold`} data-id="element-155">
            ARS
          </span>
        </div>
        {tier.value && <p className="mt-2 inline-block bg-[#C2683D]/10 text-[#C2683D] text-[10px] md:text-[11px] font-bold rounded-full px-3 py-1 leading-tight" data-id="element-156">
            {tier.value}
          </p>}
      </div>

      <a href={tier.href} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('InitiateCheckout', {
      content_name: tier.title,
      value: Number(tier.price.replace(/[^0-9]/g, '')),
      currency: 'ARS'
    })} className={`w-full block py-2.5 md:py-3 rounded-xl font-bold text-[11px] md:text-sm tracking-widest uppercase text-center transition-all hover:-translate-y-1 ${buttonClass}`} style={{
      fontFamily: "'Inter', sans-serif"
    }} data-id="element-157">
        {tier.cta} →
      </a>
    </div>;
}
export function PricingSection() {
  const [ref1, vis1] = useReveal();
  return <section id="pricing" className="bg-[#2E4F48] py-8 md:py-14 px-4 sm:px-6 border-t border-[#1C3B36]" style={{
    scrollMarginTop: '20px'
  }} data-id="element-158">
      <div className="container mx-auto max-w-4xl" data-id="element-159">
        <div ref={ref1} className={`reveal text-center mb-5 md:mb-8 ${vis1 ? 'is-visible' : ''}`} data-id="element-160">
          <span className="inline-block bg-[#C2683D] text-white text-[10px] md:text-xs font-bold tracking-[0.2em] uppercase rounded-full px-4 py-1.5 mb-3 shadow-md" data-id="element-161">
            🔥 Oferta de lanzamiento
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold leading-tight text-[#EFEAE0] mb-2" data-id="element-162">
            Empezá tu formación{' '}
            <span className="text-[#C2683D] italic" data-id="element-163">hoy mismo</span>
          </h2>
          <p className="text-[#E8E0D3]/90 text-sm md:text-base max-w-2xl mx-auto leading-relaxed" data-id="element-164">
            Incluye acceso inmediato y certificado digital.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-3.5 md:gap-6 items-stretch max-w-md mx-auto" data-id="element-165">
          {TIERS.map((tier, i) => <TierCard key={tier.id} tier={tier} index={i} data-id="element-166" />)}
        </div>
      </div>
    </section>;
}